export default __webpack_public_path__ + "static/media/human.c1fbb58c.png";